export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-logo-specs-8a2e1d7bd50318a67ef356cd72ed6a0d.png";